import { Provider } from '@angular/core';
import { APP_CONFIG_TOKEN } from './config.token';
import { Config } from './config.model';
import { ConfigService } from './config.service';

/**
 * Default configuration values.
 * These values will be used if not overridden by runtime configuration.
 */
export const defaultConfig: Config = {
  ionKey: '',
  appVersion: '',
  applicationInsightsConnectionString: '',
  turnServers: [],
};

/**
 * Dynamic config wrapper that always returns the current config state
 */
export class DynamicConfigWrapper implements Config {
  constructor(private configService: ConfigService) {}

  get ionKey(): string {
    return this.getCurrentConfig().ionKey;
  }

  get appVersion(): string {
    return this.getCurrentConfig().appVersion;
  }

  get applicationInsightsConnectionString(): string {
    return this.getCurrentConfig().applicationInsightsConnectionString;
  }

  get turnServers(): any[] {
    return this.getCurrentConfig().turnServers;
  }

  private getCurrentConfig(): Config {
    const runtimeConfig = this.configService.getRuntimeConfig();
    return {
      ...defaultConfig,
      ...runtimeConfig,
    };
  }
}

/**
 * Factory function that creates a dynamic config wrapper
 */
export function configFactory(configService: ConfigService): Config {
  return new DynamicConfigWrapper(configService);
}

/**
 * Provider for the CONFIG injection token.
 * This makes the configuration object available for dependency injection.
 */
export function provideConfig(): Provider {
  return {
    provide: APP_CONFIG_TOKEN,
    useFactory: configFactory,
    deps: [ConfigService],
  };
}
